<template>
   <div class="participant-list container-fluid margin-left-1Point7Perc"> 
        <div class="row margin-top-3Perc">
          <!--
          <span class=" margin-left-2Perc cursor-pointer pull-left border-red" v-on:click="isAllParticipantsSelected($event,true)">
            Select all 
          </span>
          <span class="margin-left-1Perc pull-left">
            |
          </span>
          <span class="margin-left-1Perc pull-left cursor-pointer border-red" v-on:click="isAllParticipantsSelected($event,false)">
            Deselect all
          </span> -->

          <span class="text-align-right float-right margin-right-1-Point-2-Perc">
            Total Participant(s) : {{totalParticipantCountValue}}
          </span>  
        </div>
        <div class="table-responsive margin-top-1-perc overflow-y-hidden">          
          <table class="table table-striped">
            <thead>
              <tr>
                <!-- <th class="text-align-center font-size-15px col-lg-1"></th> -->
                <th class="text-align-center font-size-15px border-right">Participant Name</th>
                <th class="text-align-center font-size-15px border-right">Username</th>
                <th class="text-align-center font-size-15px border-right">Email</th>
                <th class="text-align-center font-size-15px border-right">Platform</th>
                <!-- <th class="text-align-center font-size-15px border-right ">iOS Version</th> -->
                <!-- <th class="text-align-center font-size-15px border-right ">Android Version</th> -->
                <!-- <th class="text-align-center font-size-15px border-right ">Web Version</th> -->
                <th class="text-align-center font-size-15px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="participantObj in participantList" :key="participantObj.UserId">
                <!-- <td class="col-lg-1">
                  <input type="checkbox" value="true" v-model="isCheckedAllUsers">
                </td> -->
                <td class="border-right col-xs-3 col-sm-3 col-md-3 col-lg-3">{{participantObj.FirstName}} {{participantObj.LastName}}</td>
                <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1">{{participantObj.Username}}</td>
                <td class="border-right col-xs-3 col-sm-3 col-md-3 col-lg-3">{{participantObj.EmailId}}</td>
                <td class="border-right col-xs-2 col-sm-2 col-md-2 col-lg-2">
                  <div class="tooltip1">
                    <img :src="iOSIconSrc" class="img-responsive element-icon-width-height" alt="ios-icon" v-if="participantObj.iOSVersion !== null && participantObj.iOSVersion.trim().length !== 0"/>
                    <span class="tooltiptext text-break" v-if="participantObj.iOSVersion !== null && participantObj.iOSVersion.trim().length !== 0">{{participantObj.iOSVersion}}</span>
                  </div>
                  <div class="tooltip1">
                    <img :src="androidIconSrc" class="img-responsive element-icon-width-height" alt="android-icon" v-if="participantObj.AndroidVersion !== null && participantObj.AndroidVersion.trim().length !== 0"/>
                    <span class="tooltiptext text-break" v-if="participantObj.AndroidVersion !== null && participantObj.AndroidVersion.trim().length !== 0">{{participantObj.AndroidVersion}}</span>
                  </div>
                  <div class="tooltip1">
                    <img :src="webIconSrc" class="img-responsive element-icon-width-height" alt="web-icon" v-if="participantObj.WebVersion !== null && participantObj.WebVersion.trim().length !== 0"/>
                    <span class="tooltiptext text-break" v-if="participantObj.WebVersion !== null && participantObj.WebVersion.trim().length !== 0">{{participantObj.WebVersion}}</span>
                  </div>
                </td>
                <!-- <td class="border-right col-lg-1">{{participantObj.iOSVersion}}</td> -->
                <!-- <td class="border-right col-lg-1">{{participantObj.AndroidVersion}}</td> -->
                <!-- <td class="border-right col-lg-1">{{participantObj.WebVersion}}</td> -->
                <td class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                  <a class="cursor-pointer" @click="openParticipantDetailsBox($event,true,participantObj)"> View </a>|
                  <a class="cursor-pointer" @click="openEditParticipantsBox($event,true,participantObj)"> Edit </a>|
                  <a class="cursor-pointer" @click="askUserConfirmation($event,true,participantObj)"> Delete </a>|
                  <a class="cursor-pointer" @click="openUserActivityBox($event,true,participantObj)"> Activity </a>|
                  <a class="cursor-pointer" @click="openEnrollmentBox($event,participantObj)"> Enrollments </a>|
                  <a class="cursor-pointer" @click="askResetDataConfirmation($event,participantObj)"> Reset Data </a>|
                  <a class="cursor-pointer" @click="askResetMeetingMentorConfirmation($event,participantObj)"> Reset Meeting Mentor </a>|
                  <a class="cursor-pointer" @click="openSubmitRequestOverlay($event,participantObj)"> Submit Data Request </a>
                </td>  
              </tr>
            </tbody>
          </table>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <paginate
        v-if="showList"
        :page-count="TotalPages"
        :click-handler="onPageClick"
        :container-class="'pagination'"
        :page-class="'page-item'">
      </paginate>
      <loader></loader>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteParticipantString" v-bind:postfixString="postDeleteParticipantString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performOperation"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <participant-enrollment-overlay v-if="openEnrollmentOverlay" @closeEnrollmentOverlay="updateEnrollmentOverlayFlag" v-bind:userObj="selectedUserObj" v-bind:userEnrollmentList="userEnrollmentListValue"></participant-enrollment-overlay>
      <participant-details-overlay v-bind:userObj="selectedUserObj" v-if="openUserDetailsOverlay" @closeViewParticipant="closeParticipantDetailsOverlay"></participant-details-overlay> 
      <update-participant-details-overlay v-bind:userObj="selectedUserObj" v-if="openEditUserDetailsOverlay" @closeEditParticipant="closeEditParticipantDetailsOverlay" @refreshList="refreshParticipantList"></update-participant-details-overlay>
      <view-participant-activity-overlay v-bind:userObj="selectedUserObj" v-if="openUserActivityOverlay" @closeActivity="closeUserActivityOverlay"></view-participant-activity-overlay>
      <submit-user-request-overlay v-bind:userObj="selectedUserObj" v-if="showSubmitReqOverlay" @closeUserRequest="closeUserUserRequestOverlay"></submit-user-request-overlay>
      </div>    
</template>
<script>
import Paginate from 'vuejs-paginate'
import iOSIconSrc from '../assets/images/mac.svg'
import androidIconSrc from '../assets/images/android.svg'
import webIconSrc from '../assets/images/pc.svg'
import { constants } from '@/utils/constants'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import ParticipantEnrollmentOverlay from '@/components/ParticipantEnrollmentOverlay'
import AlertBox from '@/components/AlertOverlay'
import ParticipantDetailsOverlay from '@/components/ViewParticipantDetailsOverlay'
import UpdateParticipantDetailsOverlay from '@/components/UpdateParticipantDetailsOverlay'
import ViewParticipantActivityOverlay from '@/components/ViewParticipantActivityOverlay'
import SubmitUserRequestOverlay from '@/components/SubmitUserRequestOverlay'
import { participantService } from '@/server-util/participant-service'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['participantList', 'totalParticipantCount', 'usersPerPage', 'resetPagination'],
  name: 'participant-list',
  data: function () {
    return {
      isCheckedAllUsers: false,
      currentIndex: 0,
      selectedUserObj: null,
      openEnrollmentOverlay: false,
      userEnrollmentList: [],
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      openUserDetailsOverlay: false,
      openEditUserDetailsOverlay: false,
      openUserActivityOverlay: false,
      showConfirmationBox: false,
      showSubmitReqOverlay: false,
      prefixDeleteParticipantString: 'Saved Correction option(s) will be lost.',
      postDeleteParticipantString: '\nAre you sure you want to change question type?',
      iOSIconSrc: iOSIconSrc,
      androidIconSrc: androidIconSrc,
      webIconSrc: webIconSrc,
      showList: true
    }
  },
  methods: {
    onPageClick (pageNum) {
      this.$emit('changePage', pageNum)
    },
    openSubmitRequestOverlay: function (event, userobj) {
      // AK: Used to submit the user Request
      this.selectedUserObj = userobj
      this.showSubmitReqOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    closeUserUserRequestOverlay (value) {
      // AK: Used to close User Request Overlay
      this.showSubmitReqOverlay = false
      this.$store.state.isOverlayVisible = false
    },
    askResetDataConfirmation: function (event, userObj) {
      // AK: Set currently selected userobj
      this.selectedUserObj = userObj
      // AK: Ask user confirmation before delete
      this.prefixDeleteParticipantString = 'Are you sure you want to reset all data of '
      this.postDeleteParticipantString = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\'?'
      this.showConfirmationBox = true
    },
    askResetMeetingMentorConfirmation: function (event, userObj) {
      // SS: Reset the meeting mentor data
      this.selectedUserObj = userObj
      this.prefixDeleteParticipantString = 'Are you sure you want to reset the meeting mentor data of '
      this.postDeleteParticipantString = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\'?'
      this.showConfirmationBox = true
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Participant overlay
      this.showConfirmationBox = value
    },
    performOperation (value) {
      this.showConfirmationBox = false
      // AK: Used to delete the selected Participant
      if (value) {
        if (this.prefixDeleteParticipantString === 'Are you sure you want to delete ') {
          // AK: Delete selected User
          this.deleteSelectedParticipant()
        } else if (this.prefixDeleteParticipantString === 'Are you sure you want to reset the meeting mentor data of ') {
          this.resetMeetingMentor()
        } else {
          // AK: reset user data
          this.resetAllParticipantData()
        }
      }
    },
    resetAllParticipantData: function () {
      var storeObj = this.$store
      if (this.selectedUserObj.UserId !== undefined || this.selectedUserObj.length > 0) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        participantService.hardResetParticipantInfo(storeObj.state.access_token, this.selectedUserObj.UserId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              // AK: Refresh Participant List
              this.$emit('refreshList', true)
              this.showAlertDialog = true
              this.errorMsg = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\' data reset successfully.'
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      }
    },
    deleteSelectedParticipant: function () {
      var storeObj = this.$store
      if (this.selectedUserObj.UserId !== undefined || this.selectedUserObj.length > 0) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        participantService.deleteParticipant(storeObj.state.access_token, this.selectedUserObj.UserId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              // AK: Refresh Participant List
              this.$emit('refreshList', true)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      }
    },
    resetMeetingMentor: function () {
      var storeObj = this.$store
      if (this.selectedUserObj.UserId !== undefined || this.selectedUserObj.length > 0) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        participantService.resetUserMeetingMentor(storeObj.state.access_token, this.selectedUserObj.UserId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              // AK: Refresh Participant List
              this.$emit('refreshList', true)
              this.showAlertDialog = true
              this.errorMsg = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\' meeting mentor data reset successfully.'
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      }
    },
    askUserConfirmation: function (event, flagToUpdate, userObj) {
      // AK: Set currently selected userobj
      this.selectedUserObj = userObj
      // AK: Ask user confirmation before delete
      this.prefixDeleteParticipantString = 'Are you sure you want to delete '
      this.postDeleteParticipantString = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\'?'
      this.showConfirmationBox = flagToUpdate
    },
    openUserActivityBox (event, flagToUpdate, userObj) {
      // AK: Set currently selected userobj
      this.selectedUserObj = userObj
      // AK: open User activity participant overlay
      this.openUserActivityOverlay = flagToUpdate
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    closeUserActivityOverlay (value) {
      // AK: used to hide the User activity overlay after clicking on done or X
      this.openUserActivityOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    refreshParticipantList (value) {
      // AK: Re-emit event to Refresh List after doing update operation (User file)
      this.$emit('refreshList', true)
    },
    openEditParticipantsBox: function (event, flagToUpdate, userObj) {
      // AK: Set currently selected userobj
      this.selectedUserObj = userObj
      // AK: open edit participant details overlay
      this.openEditUserDetailsOverlay = flagToUpdate
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    closeEditParticipantDetailsOverlay (value) {
      // AK: used to hide the participant details overlay after clicking on done or X
      this.openEditUserDetailsOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
      // console.log('Selected User obj >>> ' + JSON.stringify(this.selectedUserObj))
    },
    openParticipantDetailsBox: function (event, flagToUpdate, userObj) {
      // AK: Set currently selected userobj
      this.selectedUserObj = userObj
      // AK: open participant details overlay
      this.openUserDetailsOverlay = flagToUpdate
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    closeParticipantDetailsOverlay (value) {
      // AK: used to hide the participant details overlay after clicking on done or X
      this.openUserDetailsOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    isAllParticipantsSelected: function (event, flagToUpdate) {
      this.isCheckedAllUsers = flagToUpdate
    },
    openEnrollmentBox: function (event, userObj) {
      // AK: Set currently selected userobj
      this.selectedUserObj = userObj
      // AK: get user enrollments from server
      this.participantEnrollments()
    },
    participantEnrollments: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .userEnrollments(
          storeObj.state.access_token,
          this.selectedUserObj.UserId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            console.log(JSON.stringify(responseObj.data))
            if (responseObj.data.UserEnrollments.length === 0) {
              this.showAlertDialog = true
              this.errorMsg = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\' is not enrolled in any course.'
            } else {
              // AK: Open enrollment overlay
              _this.openEnrollmentOverlay = true
              // AK: disable background scrolling
              _this.$store.state.isOverlayVisible = true
              _this.userEnrollmentList = responseObj.data
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateEnrollmentOverlayFlag (value) {
      // AK: hide Enrollment Overlay by clicking on close or dismiss button
      this.openEnrollmentOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = false
    }
  },
  components: {
    'participant-enrollment-overlay': ParticipantEnrollmentOverlay,
    'alert-box': AlertBox,
    'participant-details-overlay': ParticipantDetailsOverlay,
    'update-participant-details-overlay': UpdateParticipantDetailsOverlay,
    'view-participant-activity-overlay': ViewParticipantActivityOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    'submit-user-request-overlay': SubmitUserRequestOverlay,
    'paginate': Paginate
  },
  computed: {
    userEnrollmentListValue: {
      get: function () {
        return this.userEnrollmentList
      }
    },
    TotalPages: {
      get: function () {
        let pagesCount = 1
        if (this.totalParticipantCount > 0) {
          pagesCount = Math.floor(this.totalParticipantCount / this.usersPerPage)
          if (this.totalParticipantCount % this.usersPerPage > 0) {
            pagesCount += 1
          }
        }
        return pagesCount
      }
    },
    resetPaginationValue: {
      get: function () {
        return this.resetPagination
      }
    },
    totalParticipantCountValue: {
      get: function () {
        return this.totalParticipantCount
      }
    }
  },
  watch: {
    resetPaginationValue: function (newValue, oldValue) {
      // console.log('resetPaginationValue >>> ' + newValue)
      if (newValue) {
        this.showList = false
        var _this = this
        setTimeout(function () {
          _this.showList = true
        }, 100)
        _this.$emit('updatePaginationFlag', false)
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-right {
  text-align: right !important;
}
.float-right {
  float: right !important;
}
.cursor-pointer {
  cursor: pointer;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.text-align-left {
  text-align: left;
}
.background-color-dark-grey {
  background-color: #bbb !important;
}
.background-color-light-grey {
  background-color: #ddd;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.margin-top-3Perc {
  margin-top: 3% !important;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.margin-top-1-perc {
  margin-top: 1%;
}
.margin-left-1Perc{
  margin-left:1%;
}
.margin-left-2Perc{
  margin-left:2%;
}
.margin-left-1Point7Perc{
  margin-left:1.7%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-right-1-Point-2-Perc {
  margin-right: 1.2% !important;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.element-icon-width-height {
  width: 23px;
  height: 20px;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext {
    visibility: hidden;
    width: 205px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.text-break {
  word-break: break-all !important;
}
.tooltip1:hover .tooltiptext {
    visibility: visible;
}

.opacity-0Point5 {
  opacity: 0.5 !important;
}
.overflow-y-hidden{
  overflow-y: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ParticipantList.vue